module.exports = __webpack_public_path__ + "media/images/people/girl-9-abbb133613d9bca8019c6ed2ea8c5ea9.webp";